// Module
var code = `<div class="schema-form-section {{form.htmlClass}}"></div>
`;
// Exports
module.exports = code;